<template>
  <tbody v-if="payment" class="tbody">
    <tr style="height: 50px">
      <td>{{ payment.clientName }}</td>
      <td>{{ payment.clientEntity }}</td>
      <td>{{ formatDate(payment.date) }}</td>
      <td>{{ payment.transactionID }}</td>
      <td>{{ payment.amountReceived }}</td>
      <td>{{ payment.tds }}</td>
      <td>
        <a v-if="payment.advSettleId" target="_blank" :href="'/paymentreceived/' + payment.advSettleId">Link <v-icon>mdi-open-in-new</v-icon></a>
      </td>
      <td>
        <a v-if="payment.advCarryId" target="_blank" :href="'/paymentreceived/' + payment.advCarryId">Link <v-icon>mdi-open-in-new</v-icon></a>
      </td>
      <td>
        <z-confirm-button
          class="float-right"
          color="red lighten-1"
          x-small
          fab
          text
          :loading="loading"
          :message="$i18n.t('Do you want to delete this Payment ?')"
          @click="deletePayment(payment._id)"
        >
          <v-icon>mdi-trash-can-outline</v-icon>
        </z-confirm-button>
        <v-btn
          class="float-right"
          text
          fab
          x-small
          color="blue"
          :to="'/paymentreceived/' + payment._id"
        >
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
      </td>
    </tr>
  </tbody>
</template>

<script>
import { Vue, Component, Watch } from "vue-property-decorator";
import { doGet } from "@/store/common/module/apis";
import common from "@/store/common/module/common";

@Component({
  name: "PaymentsReceivedRow",
  props: {
    value: {
      default: null,
    },
    refresh: {
      default: null,
    },
  },
})
export default class PaymentsReceivedRow extends Vue {
  payment = null;
  limit = 2;

  get loading() {
    return common.loading;
  }

  isSet(_key) {
    if (
      _key != null &&
      _key != undefined &&
      _key != "null" &&
      _key != "undefined" &&
      _key != ""
    ) {
      return true;
    }
    return false;
  }

  subtract(from, value) {
    if (!this.isSet(from)) from = 0;
    if (!this.isSet(value)) value = 0;
    return this.round(from) - this.round(value);
  }

  round(value) {
    return Number(Math.round(value + "e" + 2) + "e-" + 2);
  }

  async deletePayment(paymentmade_id) {
    common.setLoading(true);
    try {
      await doGet("/api/collectible/" + paymentmade_id + "/delete");
      common.showMessage("Deleted Successfully");
      this.$emit("refresh", true);
    } catch (e) {
      common.setError(e.message);
    }
    common.setLoading(false);
  }

  zoneList = [];
  async mounted() {
    if (this.value) {
      this.payment = this.value;
    }
  }

  @Watch("value")
  onValueChange(val) {
    this.payment = val;
  }

  formatDate(date) {
    if (date) {
      const dateStr = date.toString();
      return (
        dateStr.substring(6, 8) +
        "-" +
        dateStr.substring(4, 6) +
        "-" +
        dateStr.substring(0, 4)
      );
    } else {
      return "";
    }
  }
}
</script>
